import Button from '../../../components/base/Button';

export default function HeroSection() {
  const scrollToProcess = () => {
    const whyLandingSection = document.getElementById('why-landing');
    if (whyLandingSection) {
      whyLandingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleCallClick = () => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'clic_pulsante_chiamata'
      });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center px-4 py-20 md:py-12 lg:py-16 bg-white md:mt-14">
      <style>{`
        @keyframes fire-pulse {
          0%, 100% {
            color: #c2410c;
            text-shadow: 0 0 8px rgba(194, 65, 12, 0.5);
          }
          50% {
            color: #dc2626;
            text-shadow: 0 0 12px rgba(220, 38, 38, 0.6);
          }
        }
        
        @keyframes cta-pulse {
          0%, 100% {
            transform: scale(1);
            box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
          }
          50% {
            transform: scale(1.05);
            box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
          }
        }
      `}</style>
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-8 lg:gap-16 items-start">
        <div className="text-center lg:text-left space-y-6 md:space-y-8">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 md:px-4 md:py-2 bg-white border-2 border-[#000000] text-[#000000] text-xs md:text-sm font-semibold whitespace-nowrap">
            <span className="w-2 h-2 bg-orange-500 animate-pulse" style={{ animation: 'pulse-color 2s ease-in-out infinite' }}></span>
            <span>DISPONIBILITÀ LIMITATA PER NUOVI PROGETTI</span>
          </div>
          
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#000000] leading-tight">
            Stai <span className="text-[#2563eb]">sprecando budget</span> nelle campagne? Spesso il problema è la <span className="text-[#2563eb]">Landing page</span>
          </h1>
          
          <p className="text-base md:text-lg lg:text-xl text-gray-600 max-w-2xl mx-auto lg:mx-0">
            Una pagina non ottimizzata <strong className="font-bold text-gray-900" style={{ animation: 'fire-pulse 1.5s ease-in-out infinite' }}>può bruciare fino al 60% del budget</strong> senza generare vendite o contatti.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center lg:justify-start">
            <button
              onClick={handleCallClick}
              data-cal-link="andrea-disanto-0kedbr/30min"
              data-cal-namespace="30min"
              data-cal-config='{"layout":"month_view"}'
              className="whitespace-nowrap font-medium transition-all duration-300 cursor-pointer border-2 bg-[#000000] text-white border-[#000000] hover:bg-white hover:text-[#000000] px-8 py-4 text-base md:text-lg md:px-10 md:py-5"
              style={{ animation: 'cta-pulse 2s ease-in-out infinite' }}
            >
              Prenota una call gratuita
            </button>
            <button
              onClick={scrollToProcess}
              className="whitespace-nowrap font-medium cursor-pointer border-2 bg-white text-[#000000] border-[#000000] px-8 py-4 text-sm md:text-base md:px-10 md:py-5 sm:w-auto w-full"
            >
              Perchè ti seve una Landing
            </button>
          </div>
        </div>
        
        <div className="relative mt-8 lg:mt-0">
          <div className="relative z-10 rounded-lg overflow-hidden shadow-2xl" style={{ maxHeight: '580px' }}>
            <img 
              src="https://static.readdy.ai/image/4355c335405d5d43b86c7110ab8a5984/0c9e58939e46b32449b8526f751ec355.png" 
              alt="Landing Page Professional Design" 
              className="w-full h-full object-cover"
              style={{ objectPosition: 'center 30%' }}
              loading="lazy"
            />
          </div>
          <div className="absolute -bottom-4 -right-4 w-full h-full border-4 border-[#2563eb] -z-10 hidden md:block"></div>
        </div>
      </div>
    </section>
  );
}
